export const getLevelContiguousAgainstBuiltLinearValidity = (
  contiguousAgainstBuiltLinear: number | undefined,
  maxContiguousAgainstBuiltLinear: number
): boolean =>
  contiguousAgainstBuiltLinear === undefined ||
  contiguousAgainstBuiltLinear <= maxContiguousAgainstBuiltLinear;
